import './App.css';
import RegisterPage from "./pages/profile/RegisterPage";
import LoginPage from "./pages/profile/LoginPage";
import Home from "./pages/Home";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LandingPage from "./pages/LandingPage";
import RoomDetails from './pages/RoomDetails';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BookingSlot from './pages/BookingSlot';
import NavBar from './components/NavBar';
import Foot from './components/Foot';
import BookingDetails from './pages/BookingDetails';
import ChangePassword from './pages/profile/ChangePassword';
import ForgetPassword from './pages/profile/ForgetPassword';
import UpdateProfile from './pages/profile/UpdateProfile';
import UserProfile from './pages/profile/UserProfile';
import Dashboard from './pages/admin/Dashboard';
import AllRoomDetails from './pages/admin/AllRoomDetails';
import BookingIdDetails from './pages/admin/BookingIdDetails';
import NewRoom from './pages/admin/NewRoom';
import UpdateRoom from './pages/admin/UpdateRoom';
import AllUserDetails from './pages/admin/AllUserDetails';

function App() {
  const [bookingSlotItems, setBookingSlotItems] = useState([]);
  return (
    <div className="App">
      <BrowserRouter>
        <div>
          <ToastContainer theme='dark' position='top-center' />
          <NavBar bookingSlotItems={bookingSlotItems} />
          <Routes>
            <Route path="/signup" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/home" element={<Home />} />
            <Route path="/search" element={<Home />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/room/:id" element={<RoomDetails bookingSlotItems={bookingSlotItems} setBookingSlotItems={setBookingSlotItems} />} />
            <Route path="/bookingslot" element={<BookingSlot bookingSlotItems={bookingSlotItems} setBookingSlotItems={setBookingSlotItems} />} />
            <Route path="/bookingdetails" element={<BookingDetails />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/profile/changepassword" element={<ChangePassword />} />
            <Route path="/profile/updateprofile" element={<UpdateProfile />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/allroomdetails" element={<AllRoomDetails />} />
            <Route path="/admin/newroom" element={<NewRoom />} />
            <Route path="/admin/updateroom/:id" element={<UpdateRoom />} />
            <Route path="/admin/alluserdetails" element={<AllUserDetails />} />
            <Route path="/admin/bookingiddetails/:id" element={<BookingIdDetails />} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
          <Foot />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
